var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.08887H2V8.08887H14V6.08887ZM11 10.1266H2V12.1266H11V10.1266ZM10 16.0889H2V14.0889H10V16.0889ZM14 18.96C14 19.6016 14.54 20.1266 15.2 20.1266H18.8C19.46 20.1266 20 19.6016 20 18.96V13.1266H14V18.96ZM19 10.7933H21V12.1266H13V10.7933H15L15.6667 10.1266H18.3333L19 10.7933Z",
    fill: "#98BECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDelete);
export default __webpack_public_path__ + "static/media/list_delete.0125e62c21f82f6aa1ce7cbbf6730cce.svg";
export { ForwardRef as ReactComponent };